export default __webpack_public_path__ + "static/media/IRESEN.64504df7.jpeg";